import { ActivityLineType } from "src/organization/pages/project/environment/metrics/components/activities/type";

import { ActivityFilterType } from "./type";

import type { Activity } from "@packages/client";

export const reduceAutoScale = (activities: Activity[]) => {
  return activities.reduce(
    (acc, activity) => {
      const payload = activity.payload;
      payload.deployment_type?.startsWith("autoscale")
        ? acc.activities.push(activity)
        : acc.remaining.push(activity);
      return acc;
    },
    { activities: [] as Activity[], remaining: [] as Activity[] }
  );
};

const reduceDeployment = (activitie: Activity[]) => {
  // auto deployment and autoscaling activity are mutually exclusive if one is present,
  // the other should not included the filtered in other activity type
  const { activities, remaining } = reduceAutoScale(activitie);
  return { activities: remaining, remaining: activities };
};

const defaultFilters = [
  { type: "autoscale" as ActivityLineType, reduce: reduceAutoScale },
  { type: "deployment" as ActivityLineType, reduce: reduceDeployment }
];

export const groupActivities = (
  filters: ActivityFilterType[],
  initialActivities: Activity[]
) => {
  const categorizedData: { type: ActivityLineType; activities: Activity[] }[] =
    [];
  let currentActivities = [...initialActivities];

  for (const filter of filters) {
    const { reduce, type } =
      typeof filter === "string"
        ? defaultFilters.find(f => f.type === filter) || {}
        : filter;
    if (!reduce || !type) continue;

    const { activities, remaining } = reduce(currentActivities);
    categorizedData.push({ type, activities });
    currentActivities = remaining;
  }

  return categorizedData;
};
